import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { Card, Row, Col, Table } from '@themesberg/react-bootstrap'
import { useCookies } from 'react-cookie'
import { getList } from '../../../controller/api/ticket'
import PowerTable from '../../__vietlott__/reward/sub-screen/reward-detail/game/power'
import MegaTable from '../../__vietlott__/reward/sub-screen/reward-detail/game/mega'
import KenoTable from '../../__vietlott__/reward/sub-screen/reward-detail/game/keno'
import Max3dTable from '../../__vietlott__/reward/sub-screen/reward-detail/game/max3d'
import Max3dProTable from '../../__vietlott__/reward/sub-screen/reward-detail/game/max3dpro'
import Lotto535Table from '../../__vietlott__/reward/sub-screen/reward-detail/game/lotto535'
import ImagePreview from './sub-screen/image-preview/ImagePreview'
import { MoneyLogLines } from '../../../components/MoneyLogLines'

const TableRow = (props) => {
  const { numbers, rIndex, unitValue, playMethod, gameId } = props;

  const numbersCell = useMemo(() => {
    if (gameId === 'lotto535') {
      if (playMethod.includes('GROUP_NORMAL_')) {
        return (<>{numbers.split(' ').slice(0, numbers.split(' ').length - 1).join('  ')} | <span className='text-danger'>{numbers.split(' ').slice(-1)}</span></>)
      }
      const specialLength = playMethod.split('GROUP_SPECIAL_')[1]
      return (<>{numbers.split(' ').slice(0, 5).join('  ')} | <span className='text-danger'>{numbers.split(' ').slice(-specialLength).join('  ')}</span></>)
    }
    return <td>{numbers}</td>
  }, [gameId, playMethod, numbers])

  return (
    <tr>
      <td>
        {rIndex + 1}
      </td>
      {numbersCell}
      <td>{parsePlayMethod(gameId, playMethod, numbers.split(' ').length)}</td>
      <td className="align-items-right">{new Intl.NumberFormat('vn-VI', {}).format(unitValue) || ""}</td>
    </tr>
  );
};

const TicketDetailPage = () => {
  const { id } = useParams()
  const [cookies] = useCookies(['lottmekong'])
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [modalImageShow, setModalImageShow] = useState(false)
  const [selectedImage, setSelectedImage] = useState('')
  const [previewTitle, setPreviewTitle] = useState('')

  useEffect(() => {
    document.title = `Chi tiết vé - ${id || ''}`
  }, [id])

  const fetchDetail = useCallback(async () => {
    if (!id) {
      setError('Không tìm thấy ID vé')
      setLoading(false)
      return
    }

    try {
      setLoading(true)
      setError('')
      
      const response = await getList(cookies.lottmekong, {
        ticketId: id,
        cartId: ''
      }, 0)

      if (response && response.data && response.data.length > 0) {
        const found = response.data.find(item => item.id === id)
        if (found) {
          setData(found)
        } else {
          setError('Không tìm thấy vé với ID này')
        }
      } else {
        setError('Không thể tải dữ liệu')
      }
    } catch (err) {
      console.error('Error fetching ticket detail:', err)
      setError('Có lỗi xảy ra khi tải dữ liệu')
    } finally {
      setLoading(false)
    }
  }, [id, cookies.lottmekong])

  useEffect(() => {
    fetchDetail()
  }, [fetchDetail])

  const showImagePreview = (title, image) => {
    setPreviewTitle(title)
    setSelectedImage(image)
    setModalImageShow(true)
  }

  const getStatusText = (status) => {
    if ([1, 2].indexOf(status) >= 0) return 'CHƯA IN'
    if ([3].indexOf(status) >= 0) return 'ĐÃ IN'
    if ([4].indexOf(status) >= 0) return 'ĐÃ TRÚNG THƯỞNG'
    if ([5].indexOf(status) >= 0) return 'KHÔNG TRÚNG THƯỞNG'
    if ([6].indexOf(status) >= 0) return 'Đã hủy - Hoàn tiền'
    if ([8].indexOf(status) >= 0) return 'Nhân viên hủy'
    if ([9].indexOf(status) >= 0) return 'Đã in'
    return 'ĐANG CHỜ XỬ LÝ'
  }

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Đang tải...</span>
        </div>
      </div>
    )
  }

  if (error || !data) {
    return (
      <Card border="light" className="shadow-sm">
        <Card.Body className="text-center py-5">
          <h5 className="text-danger">{error || 'Không tìm thấy dữ liệu'}</h5>
        </Card.Body>
      </Card>
    )
  }

  const numberRows = data.numberRows || []
  const images = data.images || []
  const reward = data.TransactionPayReward && data.TransactionPayReward[0] ? data.TransactionPayReward[0] : null
  const gameId = data.game?.id || ''

  if (numberRows.length === 0) {
    return (
      <Card border="light" className="shadow-sm">
        <Card.Body className="text-center py-5">
          <h5 className="text-warning">Vé không có dữ liệu</h5>
        </Card.Body>
      </Card>
    )
  }

  return (
    <>
      <Card border="light" className="shadow-sm mb-4">
        <Card.Header>
          <h5 className="mb-0">
            Mã vé: {data.id} {gameId}
          </h5>
        </Card.Header>
        <Card.Body>
          <h5>
            {getStatusText(data.status)}
          </h5>
          <div className="mb-3">
            <strong>Dòng tiền</strong>
            <MoneyLogLines logs={[
              ...((data.cart && data.cart.transactions) || []).map((tx) => tx.moneyLog ? {
                ...tx.moneyLog,
                label: 'Mua vé',
                mismatch: tx.moneyLog.ref !== tx.id || tx.moneyLog.type !== 'Transaction',
              } : null),
              ...(data.TransactionPayReward || []).map((tx) => tx.rewardMoneyLog ? {
                ...tx.rewardMoneyLog,
                label: 'Trả thưởng',
                mismatch: tx.rewardMoneyLog.ref !== tx.id || tx.rewardMoneyLog.type !== 'TransactionPayReward',
              } : null),
            ]} />
          </div>
          <Table responsive className="align-items-center table-flush">
            <thead className="thead-light">
              <tr>
                <th scope="col">STT</th>
                <th scope="col">Dãy số</th>
                <th scope="col">Cách chơi</th>
                <th scope="col">Giá trị</th>
              </tr>
            </thead>
            <tbody>
              {numberRows && numberRows.map((pv, index) => (
                <TableRow 
                  gameId={gameId} 
                  rIndex={index} 
                  key={`rows-keys-lottmekong-${pv.id}`} 
                  {...pv} 
                />
              ))}
            </tbody>
          </Table>
          <Row className="mt-4">
            <Col>
              <strong>Hình ảnh vé</strong>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <img
                alt=''
                height={200}
                src={images[0]}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  showImagePreview('Mặt trước', images[0])
                }}
              />
            </Col>
            {images[1] && (
              <Col>
                <img
                  alt=''
                  height={200}
                  src={images[1]}
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    showImagePreview('Mặt sau', images[1])
                  }}
                />
              </Col>
            )}
          </Row>
          {data.status === 4 && reward && (
            <>
              <Row className="mt-4">
                <Col>
                  <strong>Thông tin giải thưởng</strong>
                </Col>
              </Row>
              <Row>
                {reward.ticket && reward.ticket.gameId === 'power' && (
                  <PowerTable numberRows={reward.ticket.numberRows} />
                )}
                {reward.ticket && reward.ticket.gameId === 'mega' && (
                  <MegaTable numberRows={reward.ticket.numberRows} />
                )}
                {reward.ticket && reward.ticket.gameId === 'keno' && (
                  <KenoTable numberRows={reward.ticket.numberRows} />
                )}
                {reward.ticket && reward.ticket.gameId === 'max3d' && (
                  <Max3dTable numberRows={reward.ticket.numberRows} />
                )}
                {reward.ticket && reward.ticket.gameId === 'max3dpro' && (
                  <Max3dProTable numberRows={reward.ticket.numberRows} />
                )}
                {reward.ticket && reward.ticket.gameId === 'lotto535' && (
                  <Lotto535Table numberRows={reward.ticket.numberRows} />
                )}
              </Row>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', marginTop: '1rem' }}>
                <div style={{ flex: 3, justifyContent: 'flex-end', textAlign: 'end' }}>Tiền thưởng:</div>
                <div style={{ flex: 1, justifyContent: 'flex-end', textAlign: 'end' }}>
                  <strong>{new Intl.NumberFormat('vn-VI', {}).format(reward.grossValue) || ""}</strong>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                <div style={{ flex: 3, justifyContent: 'flex-end', textAlign: 'end' }}>Thuế:</div>
                <div style={{ flex: 1, justifyContent: 'flex-end', textAlign: 'end' }}>
                  <strong>{new Intl.NumberFormat('vn-VI', {}).format(reward.tax) || ""}</strong>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                <div style={{ flex: 3, justifyContent: 'flex-end', textAlign: 'end' }}>Tiền thưởng sau thuế:</div>
                <div style={{ flex: 1, justifyContent: 'flex-end', textAlign: 'end' }}>
                  <strong>{new Intl.NumberFormat('vn-VI', {}).format(reward.netValue) || ""}</strong>
                </div>
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      <ImagePreview
        show={modalImageShow}
        title={previewTitle}
        image={selectedImage}
        onHide={() => setModalImageShow(false)}
      />
    </>
  )
}

// Helper functions from original TicketDetail.js
const parseKenoPlayMethod = (method) => {
  switch (method) {
    case 'LEVEL_1': return 'Bậc 1'
    case 'LEVEL_2': return 'Bậc 2'
    case 'LEVEL_3': return 'Bậc 3'
    case 'LEVEL_4': return 'Bậc 4'
    case 'LEVEL_5': return 'Bậc 5'
    case 'LEVEL_6': return 'Bậc 6'
    case 'LEVEL_7': return 'Bậc 7'
    case 'LEVEL_8': return 'Bậc 8'
    case 'LEVEL_9': return 'Bậc 9'
    case 'LEVEL_10': return 'Bậc 10'
    case 'UPPER': return 'Lớn'
    case 'LOWER': return 'Nhỏ'
    case 'EVEN': return 'Chẵn'
    case 'ODD': return 'Lẻ'
    case 'DRAW_UPPER_LOWER': return 'Hòa lớn nhỏ'
    case 'DRAW_ODD_EVEN': return 'Hòa chẵn lẻ'
    case 'EVEN_1112': return 'Chẵn 11-12'
    case 'ODD_1112': return 'Lẻ 11-12'
    default: return '';
  }
}

const parseMegaPlayMethod = (method) => {
  switch (method) {
    case 'GROUP_18': return 'Bao 18'
    case 'GROUP_15': return 'Bao 15'
    case 'GROUP_14': return 'Bao 14'
    case 'GROUP_13': return 'Bao 13'
    case 'GROUP_12': return 'Bao 12'
    case 'GROUP_11': return 'Bao 11'
    case 'GROUP_10': return 'Bao 10'
    case 'GROUP_9': return 'Bao 9'
    case 'GROUP_8': return 'Bao 8'
    case 'GROUP_7': return 'Bao 7'
    case 'GROUP_5': return 'Bao 5'
    case 'GROUP_6': return 'Vé thường'
    default: break;
  }
}

const parseMax3dProPlayMethod = (method, numbers = 0) => {
  switch (method) {
    case 'MULTIGROUP': return `Bao ${numbers} bộ số`
    case 'GROUP': return `Bao bộ số`
    default: return 'BÌNH THƯỜNG';
  }
}

const parseLotto535PlayMethod = (method) => {
  switch (method) {
    case 'GROUP_NORMAL_15': return 'Bao 15'
    case 'GROUP_NORMAL_14': return 'Bao 14'
    case 'GROUP_NORMAL_13': return 'Bao 13'
    case 'GROUP_NORMAL_12': return 'Bao 12'
    case 'GROUP_NORMAL_11': return 'Bao 11'
    case 'GROUP_NORMAL_10': return 'Bao 10'
    case 'GROUP_NORMAL_9': return 'Bao 9'
    case 'GROUP_NORMAL_8': return 'Bao 8'
    case 'GROUP_NORMAL_7': return 'Bao 7'
    case 'GROUP_NORMAL_6': return 'Bao 6'
    case 'GROUP_NORMAL_5': return 'Vé thường'
    case 'GROUP_NORMAL_4': return 'Bao 4'
    case 'GROUP_SPECIAL_2': return 'Bao 2 đặc biệt'
    case 'GROUP_SPECIAL_3': return 'Bao 3 đặc biệt'
    case 'GROUP_SPECIAL_4': return 'Bao 4 đặc biệt'
    case 'GROUP_SPECIAL_5': return 'Bao 5 đặc biệt'
    case 'GROUP_SPECIAL_6': return 'Bao 6 đặc biệt'
    case 'GROUP_SPECIAL_7': return 'Bao 7 đặc biệt'
    case 'GROUP_SPECIAL_8': return 'Bao 8 đặc biệt'
    case 'GROUP_SPECIAL_9': return 'Bao 9 đặc biệt'
    case 'GROUP_SPECIAL_10': return 'Bao 10 đặc biệt'
    case 'GROUP_SPECIAL_11': return 'Bao 11 đặc biệt'
    case 'GROUP_SPECIAL_12': return 'Bao 12 đặc biệt'
    default: break;
  }
}

const parsePlayMethod = (gameId, method, numbers = 0) => {
  switch (gameId) {
    case 'keno': return parseKenoPlayMethod(method);
    case 'mega': return parseMegaPlayMethod(method);
    case 'power': return parseMegaPlayMethod(method);
    case 'max3d': return method;
    case 'max3dpro': return parseMax3dProPlayMethod(method, numbers);
    case 'lotto535': return parseLotto535PlayMethod(method);
    default: return '';
  }
}

export default TicketDetailPage
